import React from "react";
import { Card, CardContent, Chip, Typography } from "@mui/material";

function Header() {
  return (
    <Card
      sx={{
        maxWidth: 500, 
        mx: "auto",
        mt: 4, 
        borderRadius: 4,
        p: 2, 
      }}
    >
      <CardContent>
        <Chip
          label="CPU Price Tracker"
          color="primary"
          variant="outlined"
          sx={{
            fontSize: "1.5rem",
            fontWeight: "bold",
            transition: "all 0.3s ease",
            "&:hover": {
              backgroundColor: "white",
              color: "black",
              boxShadow: "0 0 20px rgba(255, 255, 255, 0.8)",
              transform: "scale(1.1)",
            },
          }}
        />
        <Typography variant="body1" color="text.secondary" sx={{ mt: 2, fontSize: "1rem" }}>
          Find and track the prices of CPUs in real-time.
        </Typography>
      </CardContent>
    </Card>
  );
}

export default Header;